export enum AMENITIES {
	TV,
	VIDEO_CONFERENCING,
	PHONE,
	COMPUTER,
	WHITEBOARD,
	PROJECTOR,
}
